import { CubePresenter, FlipIntent, Logger, Presenter } from 'wdc-cube'

import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { MainPresenter } from 'src/main/Main.presenter'
import { GrupoFormKeys } from './form'
import GrupoKeys from './grupo.keys'
import GrupoScope, { HeaderScope } from './grupo.scopes'
import grupoService from './grupo.service'

const LOG = Logger.get('GrupoPresenter')

export class GrupoPresenter extends CubePresenter<MainPresenter, GrupoScope> {
    // :: Fields

    private readonly __headerBar: Presenter<HeaderScope, GrupoPresenter>

    // :: Constructor

    public constructor(app: MainPresenter) {
        super(app, new GrupoScope())
        this.__headerBar = new Presenter(this, this.scope.header)
    }

    // :: Methods

    public override release() {
        this.app.releaseToolbar(this.__headerBar)
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new GrupoKeys(this.app, intent)

        this.app.scope.toolbar = this.__headerBar.scope

        keys.parentSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }
        if (!this.scope.grupos || this.scope.grupos.length === 0) {
            await this.handleFind()
        }

        return keys.allow
    }

    async #initialize() {
        LOG.debug('initialize')
        this.scope.onFind = this.action(this.handleFind)
        this.scope.onNew = this.action(this.handleNew)
        this.scope.onEdit = this.action(this.handleEdit)
        this.scope.onDelete = this.action(this.handleDelete)
    }

    async handleEditGroup(grupoId: number) {
        const target = new GrupoFormKeys(this.app)
        target.grupoId = grupoId
        await target.flip()
    }

    private async handleFind() {
        try {
            this.scope.waiting = new WaitingScope()
            const grupos = await grupoService.fetchGrupos()
            this.scope.grupos = grupos
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }

    private async handleNew() {
        const target = new GrupoFormKeys(this.app)
        await target.flip()
    }

    private async handleEdit() {
        const target = new GrupoFormKeys(this.app)
        target.grupoId = this.scope.idSelected
        await target.flip()
    }

    private async handleDelete() {
        try {
            if (!this.scope.idSelected) {
                throw new Error('Grupo deve ser selecionado')
            }
        } catch (caught) {
            LOG.error('handleDelete', caught)
            throw caught
        }
    }
}

export default GrupoPresenter
